import {View, Text, TouchableOpacity} from 'react-native';
import React, { useEffect } from 'react';
import {styles} from './styles';
import {Image} from 'react-native';
import {Images} from '../../constants/Images';

interface IToast {
  title?: string;
  error?: boolean;
  visible: boolean;
  onHide: () => void
}

const ToastDismissible = ({title, error, visible, onHide}: IToast) => {

  useEffect(() => {
    if(!visible) {
      return
    }

    const timeout = setTimeout(() => onHide(), 5000)

    return () => clearTimeout(timeout)
  },[visible])

  if(!visible) {
    return <></>
  }
  return (
    <TouchableOpacity style={[styles.toast, error && styles.errorToast]} onPress={onHide}>
      {Images.checkToast && (
        <Image source={Images.checkToast} style={styles.check} />
      )}
      <Text style={styles.toastText}>{title}</Text>
    </TouchableOpacity>
  );
};

export default ToastDismissible;
